package com.appsyde.shared.presentation.screen.component.menu.helper

import com.appsyde.shared.modules.ai.domain.model.DetectedFieldV2
import com.appsyde.shared.presentation.screen.component.message.mapper.isYesValue
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLTextAreaElement

fun String?.maskEmailForUi(): String? {
    val e = this?.trim().orEmpty()
    if (e.isBlank()) return null
    return e
}

fun copyToClipboard(text: String) {
    val value = text.trim()
    if (value.isEmpty()) return

    val clipboard = window.navigator.clipboard
    if (clipboard != null) {
        clipboard.writeText(value)
        return
    }

    val t = document.createElement("textarea") as HTMLTextAreaElement
    t.value = value
    document.body?.appendChild(t)
    t.select()
    document.execCommand("copy")
    t.remove()
}

fun DetectedFieldV2.isSingleLine(): Boolean {
    val k = key?.trim().orEmpty()
    val v = value?.trim().orEmpty()
    if (v.isEmpty()) return true
    if (k in setOf("delivery_address", "delivery_note", "issue", "missing_item")) return false
    if (v.isYesValue()) return true
    return v.length <= 23
}
